import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fade from "react-reveal/Fade";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";

import { ThemeContext } from "../../contexts/ThemeContext";

import expImgWhite from "../../assets/svg/experience/expImgWhite.svg";
import expImgBlack from "../../assets/svg/experience/expImgBlack.svg";

import "./Experience.css";

function ExperienceCard({
  id,
  company,
  jobtitle,
  startYear,
  endYear,
  description,
  technologies,
}) {
  const { theme } = useContext(ThemeContext);
  const [expanded, setExpanded] = useState(false);

  const useStyles = makeStyles((t) => ({
    experienceCard: {
      backgroundColor: theme.primary30,
      transition: "all 0.3s ease",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.primary50,
        transform: "translateY(-5px)",
        boxShadow: `0 10px 20px ${theme.primary30}`,
      },
    },
  }));

  const classes = useStyles();

  return (
    <Fade bottom>
      <div
        key={id}
        className={`experience-card ${classes.experienceCard}`}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="expcard-img" style={{ backgroundColor: theme.primary }}>
          <img
            draggable={false}
            src={theme.type === "light" ? expImgBlack : expImgWhite}
            alt=""
          />
        </div>
        <div className="experience-details">
          <h6 style={{ color: theme.primary }}>
            {startYear} - {endYear}
          </h6>
          <h4 style={{ color: theme.tertiary }}>{jobtitle}</h4>
          <h5 style={{ color: theme.tertiary80 }}>{company}</h5>

          {description && (
            <div
              className="experience-expand-icon"
              style={{ color: theme.primary }}
            >
              {expanded ? (
                <IoMdArrowDropup size={24} />
              ) : (
                <IoMdArrowDropdown size={24} />
              )}
            </div>
          )}

          {expanded && description && (
            <div className="experience-expanded-content">
              <ul
                style={{
                  color: theme.tertiary80,
                  marginTop: "12px",
                  lineHeight: "1.6",
                  paddingLeft: "20px",
                  marginBottom: "0",
                }}
              >
                {Array.isArray(description) ? (
                  description.map((bullet, index) => (
                    <li
                      key={index}
                      style={{
                        marginBottom: "8px",
                        fontSize: "0.9rem",
                      }}
                    >
                      {bullet}
                    </li>
                  ))
                ) : (
                  <li style={{ marginBottom: "8px", fontSize: "0.9rem" }}>
                    {description}
                  </li>
                )}
              </ul>
              {technologies && (
                <div style={{ marginTop: "12px" }}>
                  <strong style={{ color: theme.primary, fontSize: "0.9rem" }}>
                    Tech Stack:{" "}
                  </strong>
                  <span
                    style={{ color: theme.tertiary80, fontSize: "0.85rem" }}
                  >
                    {technologies}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Fade>
  );
}

export default ExperienceCard;
